import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a popup
 *
 * This functionality is now moved to the media hotspot
 */
export default class NoteHotspot extends BaseHotspot {
  /**
   * Initialises an note hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'note',
   *   options: {
   *     title: 'Title',
   *     content: 'Content'
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    if (
      !this._config.options.title &&
      !this._config.options.content &&
      !this._config.options.image
    ) {
      this.loadTexture({
        url: `${window.location.origin}/tour/assets/hotspots/note.png`,
      });
    } else if (this._config.options.audio || this._config.options.image) {
      // hardcoding for cobuilder tour
      // TODO: remove
      if (window.location.pathname.includes("AM-437D")) {
        this.loadTexture({
          url: `${window.location.origin}/tour/assets/hotspots/warning.png`,
        });
      } else {
        this.loadTexture({
          url: `${window.location.origin}/tour/assets/hotspots/info-plus.png`,
        });
      }
    } else {
      this.loadTexture({
        url: `${window.location.origin}/tour/assets/hotspots/info.png`,
      });
    }

    this._config = config;
  }
}
